/**
 * ADD RSS FEED ACTIONS
 *
 * Description here.
 *
 * @version 0.1
 */

import { hashHistory } from 'react-router';

import reduxStore from './../../../reduxStore';
import xhr from './../../../utils/xhr';
import utils from './../../../utils/utilities';

import popupActions from './../../../reusable/MessagePopup/redux/MessagePopup.actions.js';
import categoriesApi from './../../../api/Categories.api'

import { POPUP_LIFETIME } from './../../../constants';

// Define action constants
export const ADD_RSS_RESET_PAGE = 'ADD_RSS_RESET_PAGE';
export const ADD_RSS_CHANGE_FEED_DATA = 'ADD_RSS_CHANGE_FEED_DATA';
export const ADD_RSS_SET_CATEGORIES = 'ADD_RSS_SET_CATEGORIES';
export const ADD_RSS_CHANGE_THIRD_PARTIES_URL_PARAMS = 'ADD_RSS_CHANGE_THIRD_PARTIES_URL_PARAMS';
export const ADD_RSS_SELECT_THIRD_PARTIES_OPTION = 'ADD_RSS_SELECT_THIRD_PARTIES_OPTION';
export const ADD_RSS_CHANGE_RISK_ANGLES = 'ADD_RSS_CHANGE_RISK_ANGLES';
export const ADD_RSS_SELECT_CATEGORY = 'ADD_RSS_SELECT_CATEGORY';
export const ADD_RSS_DESELECT_CATEGORY = 'ADD_RSS_DESELECT_CATEGORY';
export const ADD_RSS_CLEAR_SELECTED_THIRD_PARTIES = 'ADD_RSS_CLEAR_SELECTED_THIRD_PARTIES';
export const ADD_RSS_SELECT_THIRD_PARTIES = 'ADD_RSS_SELECT_THIRD_PARTIES';
export const ADD_RSS_COUNT_THIRD_PARTIES = 'ADD_RSS_COUNT_THIRD_PARTIES';
export const ADD_RSS_FILTER_COUNT_THIRD_PARTIES = 'ADD_RSS_FILTER_COUNT_THIRD_PARTIES';
export const ADD_RSS_SELECT_THIRD_PARTIES_SHOW_SPINNER = 'ADD_RSS_SELECT_THIRD_PARTIES_SHOW_SPINNER';
export const ADD_RSS_SELECT_THIRD_PARTIES_HIDE_SPINNER = 'ADD_RSS_SELECT_THIRD_PARTIES_HIDE_SPINNER';
export const ADD_RSS_DESELECT_THIRD_PARTY = 'ADD_RSS_DESELECT_THIRD_PARTY';
export const ADD_RSS_SELECT_ALL_CATEGORIES = 'ADD_RSS_SELECT_ALL_CATEGORIES';
export const ADD_RSS_DESELECT_ALL_CATEGORIES = 'ADD_RSS_DESELECT_ALL_CATEGORIES';
export const ADD_RSS_SAVE_ERROR = 'ADD_RSS_SAVE_ERROR';
export const ADD_RSS_CLEAR_SAVE_ERRORS = 'ADD_RSS_CLEAR_SAVE_ERRORS';
export const ADD_RSS_FEED_NAME_VALIDATED = 'ADD_RSS_FEED_NAME_VALIDATED';
export const ADD_RSS_FEED_NAME_INVALIDATED = 'ADD_RSS_FEED_NAME_INVALIDATED';
export const ADD_RSS_TABLE_URL_CHANGE = 'ADD_RSS_TABLE_URL_CHANGE';
export const ADD_RSS_SELECT_THIRD_PARTIES_SET = 'ADD_RSS_SELECT_THIRD_PARTIES_SET';
export const ADD_RSS_DESELECT_THIRD_PARTIES_SET = 'ADD_RSS_DESELECT_THIRD_PARTIES_SET';
export const ADD_RSS_SET_SELECTED_CATEGORIES = 'ADD_RSS_SET_SELECTED_CATEGORIES';
export const ADD_RSS_SET_SELECTED_THIRDPARTIES = 'ADD_RSS_SET_SELECTED_THIRDPARTIES';

// Define action constants
const actions = {

    resetAddRssFeedPage: () => {
        reduxStore.dispatch({type: ADD_RSS_RESET_PAGE});
    },

    changeFeedData: (feedData) => {
        reduxStore.dispatch({
            type:    ADD_RSS_CHANGE_FEED_DATA,
            payload: feedData
        });
    },

    toggleFeedNameValidation: (isValid) => {
        reduxStore.dispatch({
            type: isValid ? ADD_RSS_FEED_NAME_VALIDATED : ADD_RSS_FEED_NAME_INVALIDATED
        });
    },

    addValidationError: (errorId) => {
        reduxStore.dispatch({
            type:    ADD_RSS_SAVE_ERROR,
            payload: errorId
        });
    },

    clearValidationErrors: (errors = null) => {
        reduxStore.dispatch(
            {
                type:    ADD_RSS_CLEAR_SAVE_ERRORS,
                payload: errors
            }
        );
    },

    validateNameField: (feedName, feedId) => {

        let inputSpinner = document.getElementsByClassName("js-input-spinner")[0],
            payload      = {name: feedName};

        if (feedId) {
            payload['id'] = feedId;
        }

        // show spinner until server responds
        inputSpinner.classList.add('shown');

        return xhr.post({

            url:  '/api/feeds/duplicateName/',
            // Update to send TO with id and name (new feed id is null)
            data: payload
        }).then((response) => {

            if (response.body == false) {

                actions.clearValidationErrors(['api.error.feed.missingTitle', 'api.error.feed.duplicateTitle']);

                // Reset spinner to hidden
                inputSpinner.classList.remove('shown');

            } else {

                // Add error to stack
                actions.addValidationError('api.error.feed.missingTitle');

                // Reset spinner to hidden
                // inputSpinner.classList = 'loading-spinner-image js-input-spinner';
                inputSpinner.classList.remove('shown');

            }

        }).catch((error) => {
            if (error.status === 400) {
                // Reset spinner to hidden
                // inputSpinner.classList = 'loading-spinner-image js-input-spinner';
                inputSpinner.classList.remove('shown');

                // Show error message of validation request fail.
                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'addRssFeed.feedInfo.systemError',
                            messageType: 'system-error'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
            } else {
                xhr.handleAllErrors(error);
            }

            console.log("********************** Feed Name Validation Failed ********************");
        });

    },

    changeTableUrlParams: (paramsToChange) => {
        reduxStore.dispatch({
            type:    ADD_RSS_CHANGE_THIRD_PARTIES_URL_PARAMS,
            payload: paramsToChange
        });
    },

    selectThirdParties: (itemIds) => {
        reduxStore.dispatch(
            {
                type:    ADD_RSS_SELECT_THIRD_PARTIES,
                payload: itemIds
            }
        );
    },

    refreshTable: () => {
        let refreshToggle = reduxStore.getState().addRssFeed.thirdParties.urlParams.refreshToggle;

        reduxStore.dispatch({
            type:    ADD_RSS_TABLE_URL_CHANGE,
            payload: {
                refreshToggle: refreshToggle === 0 ? 1 : 0
            }
        });
    },

    clearThirdParties: () => {
        reduxStore.dispatch({
            type: ADD_RSS_CLEAR_SELECTED_THIRD_PARTIES
        });
    },

    deselectThirdParty: (itemIndex) => {
        reduxStore.dispatch(
            {
                type:    ADD_RSS_DESELECT_THIRD_PARTY,
                payload: itemIndex
            }
        );
    },

    selectThirdPartiesOption: (selection) => {
        reduxStore.dispatch({type: ADD_RSS_SELECT_THIRD_PARTIES_OPTION, payload: selection});
    },

    changeRiskAngles: (riskAngles) => {
        reduxStore.dispatch({
            type:    ADD_RSS_CHANGE_RISK_ANGLES,
            payload: riskAngles
        });
    },

    saveFeed: (feedData, saveRequestMethod, parseErrors) => {

        let customXhr = saveRequestMethod === 'put' ? xhr.put : xhr.post;

        return customXhr({
            url:  '/api/feeds/',
            data: feedData
        }).then(() => {
            hashHistory.push('/feeds');
        }).catch((error) => {
            if (error.status === 400) {
                parseErrors(error.response.body);
            } else {
                xhr.handleAllErrors(error);
            }
        });

    },

    requestCategoryLabels: () => {
        reduxStore.dispatch(
            {
                type: ADD_RSS_SELECT_THIRD_PARTIES_SHOW_SPINNER
            }
        );
        return categoriesApi
                .getCategoryNames()
                .then((categories) => {
                    reduxStore.dispatch(
                        {
                            type: ADD_RSS_SET_CATEGORIES,
                            payload: categories
                        }
                    );
                    reduxStore.dispatch(
                        {
                            type: ADD_RSS_SELECT_THIRD_PARTIES_HIDE_SPINNER
                        }
                    );
                    return categories;
                }).catch((error) => {
                    console.log(error);
                    reduxStore.dispatch(
                        {
                            type: ADD_RSS_SELECT_THIRD_PARTIES_HIDE_SPINNER
                        }
                    );
                    xhr.handleAllErrors(error);
                });
    },

    toggleCategory: (categoryId, itemIndex) => {

        if (itemIndex === -1) {

            reduxStore.dispatch({
                type:    ADD_RSS_SELECT_CATEGORY,
                payload: categoryId
            });

        } else {

            reduxStore.dispatch({
                type:    ADD_RSS_DESELECT_CATEGORY,
                payload: itemIndex
            });

        }

    },

    toggleSelectAllCategories: (isSelectAllAction) => {

        reduxStore.dispatch({
            type: isSelectAllAction ? ADD_RSS_SELECT_ALL_CATEGORIES : ADD_RSS_DESELECT_ALL_CATEGORIES
        });

    },

    addSelectedItems: (selectedItems) => {

        reduxStore.dispatch({
            type:    ADD_RSS_SELECT_THIRD_PARTIES_SET,
            payload: selectedItems
        });

    },

    removeSelectedItems: (selectedItems) => {
        reduxStore.dispatch({
            type:    ADD_RSS_DESELECT_THIRD_PARTIES_SET,
            payload: selectedItems
        });
    },

    countEntries: () => {
        let url='/api/entities/companies/active/count';

        reduxStore.dispatch({type: 'ADD_RSS_COUNT_THIRD_PARTIES', payload: null});
        reduxStore.dispatch({type: 'ADD_RSS_FILTER_COUNT_THIRD_PARTIES', payload: null});
        let params = reduxStore.getState().addRssFeed.thirdParties.urlParams;

        xhr.get({
            url:     url
        }).then((response) => {
            reduxStore.dispatch({type: 'ADD_RSS_COUNT_THIRD_PARTIES', payload: response.body});

            if (!params.categoryIdFilter && !params.searchFilter) {
                reduxStore.dispatch({type: 'ADD_RSS_FILTER_COUNT_THIRD_PARTIES', payload: response.body});
            }
        }).catch((error) => {
            utils.logError(error, 'BaseFeedEditing.actions.countEntries(): ');

            if (error.status === 400) {
                reduxStore.dispatch({type: 'ADD_RSS_COUNT_THIRD_PARTIES', payload: 0});
                reduxStore.dispatch({type: 'ADD_RSS_FILTER_COUNT_THIRD_PARTIES', payload: 0});
            } else {
                xhr.handleAllErrors(error);
            }
        });

        if (params.categoryIdFilter || params.searchFilter) {
            let queryParams = {};

            if (params.categoryIdFilter) {
                queryParams['categoryIdFilter'] = params.categoryIdFilter;
            }

            if (params.searchFilter) {
                queryParams['searchFilter'] = params.searchFilter;
            }

            xhr.get({
                url: url,
                data: queryParams
            }).then((response) => {
                reduxStore.dispatch({type: 'ADD_RSS_FILTER_COUNT_THIRD_PARTIES', payload: response.body});
            }).catch((error) => {
                utils.logError(error, 'BaseFeedEditing.actions.countEntries(): ');

                if (error.status === 400) {
                    reduxStore.dispatch({type: 'ADD_RSS_FILTER_COUNT_THIRD_PARTIES', payload: 0});
                } else {
                    xhr.handleAllErrors(error);
                }
            });
        }
    },


    selectAll: () => {
        let state = reduxStore.getState().addRssFeed.thirdParties;
        let queryParams = {
            pageNumber: -1,
            pageSize: -1,
            sortBy: state.urlParams.sortBy,
            direction: state.urlParams.direction
        };

        if (state.urlParams.categoryIdFilter) {
            queryParams['categoryIdFilter'] = state.urlParams.categoryIdFilter;
        }

        if (state.urlParams.searchFilter) {
            queryParams['searchFilter'] = state.urlParams.searchFilter;
        }

        return xhr.get({
            url: '/api/entities/active',
            data: queryParams
        }).then((response)=> {
            actions.addSelectedItems(response.body);
        }).catch((err) => {
            console.log("********************** Failed to select all ********************");
            console.log(err);
            xhr.handleAllErrors(err);
        });
    },

    unSelectAll: () => {
        let state = reduxStore.getState().addRssFeed.thirdParties;
        let queryParams = {
            pageNumber: -1,
            pageSize: -1,
            sortBy: state.urlParams.sortBy,
            direction: state.urlParams.direction
        };

        if (state.urlParams.categoryIdFilter) {
            queryParams['categoryIdFilter'] = state.urlParams.categoryIdFilter;
        }

        if (state.urlParams.searchFilter) {
            queryParams['searchFilter'] = state.urlParams.searchFilter;
        }

        return xhr.get({
            url: '/api/entities/active',
            data: queryParams
        }).then((response)=> {
            actions.removeSelectedItems(response.body);
        }).catch((err) => {
            console.log("********************** Failed to select all ********************");
            console.log(err);
            xhr.handleAllErrors(err);
        });
    }
    //-- End feedInformation component actions

};

export default actions;


// WEBPACK FOOTER //
// ./src/scripts/pages/RSSEditing/BaseFeedEditingComponent/BaseFeedEditingComponent.actions.js